<template>
  <div class="color-field">
    <label class="field-label">
      <i :class="'fa-solid fa-' + icon"></i>
      {{ label }}
    </label>
    <div class="color-input-group">
      <input 
        type="color" 
        class="color-picker"
        :value="modelValue || '#000000'"
        @input="updateColor($event.target.value)"
      />
      <input 
        type="text" 
        class="field-input color-text"
        :value="modelValue"
        @input="updateColor($event.target.value)"
        @blur="$emit('update')"
        :placeholder="placeholder"
        maxlength="7"
        pattern="^#[0-9A-Fa-f]{6}$"
      />
    </div>
    <div v-if="modelValue" class="color-preview" :style="{ backgroundColor: modelValue }"></div>
  </div>
</template>

<script>
export default {
  name: 'ColorField',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'palette'
    },
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '#000000'
    }
  },
  emits: ['update:modelValue', 'update'],
  methods: {
    updateColor(value) {
      // Validar formato hexadecimal
      if (value && !value.startsWith('#')) {
        value = '#' + value;
      }
      if (value && /^#[0-9A-Fa-f]{6}$/.test(value)) {
        this.$emit('update:modelValue', value);
      } else if (!value) {
        this.$emit('update:modelValue', '');
      }
    }
  }
};
</script>

<style scoped>
/* Campos de cor */
.color-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.field-label {
  color: var(--text-secondary, #64748b);
  font-weight: 500;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.field-label i {
  color: var(--accent-color, #3b82f6);
  font-size: 0.85rem;
}

.color-input-group {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.color-picker {
  width: 60px !important;
  height: 44px !important;
  border: 2px solid var(--border-color, #e2e8f0) !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  background: none !important;
  padding: 0 !important;
}

.color-picker:focus {
  outline: none !important;
  border-color: var(--accent-color, #3b82f6) !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.field-input {
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color, #e2e8f0);
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  background: var(--input-background, #ffffff);
  color: var(--text-primary, #1e293b);
}

.field-input:focus {
  outline: none;
  border-color: var(--accent-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.field-input:invalid {
  border-color: var(--danger-color, #ef4444);
}

.color-text {
  flex: 1 !important;
  font-family: 'Courier New', monospace !important;
  text-transform: uppercase !important;
}

.color-preview {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  border: 1px solid var(--border-color, #e2e8f0);
  margin-top: 0.25rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .color-input-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .color-picker {
    width: 100% !important;
  }
}
</style> 